import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-no-ssr.js");
import(/* webpackMode: "eager" */ "/app/src/components/Chakra/index.tsx");
import(/* webpackMode: "eager" */ "/app/src/features/branches/components/BranchDetail.tsx");
import(/* webpackMode: "eager" */ "/app/src/features/feeds/components/Back.tsx");
import(/* webpackMode: "eager" */ "/app/src/features/feeds/components/Border.tsx");
import(/* webpackMode: "eager" */ "/app/src/features/feeds/components/Card.tsx");
import(/* webpackMode: "eager" */ "/app/src/features/feeds/components/FeedList.tsx");
import(/* webpackMode: "eager" */ "/app/src/features/feeds/components/KeywordBox.tsx");
import(/* webpackMode: "eager" */ "/app/src/features/feeds/components/ShareButton.tsx")